<template>
  <div class="animated fadeIn" ref="wrapper">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
            style="margin-bottom: 2em"
          >
            <div style="width: 50%">
              <div>{{ company.name }}</div>
              <div>{{ $t("Social Headquarters") }}: {{ company.address }}</div>
              <div>{{ $t("Reg. No. Trade Register") }}: {{ company.cui }}</div>
              <div>
                {{ $t("Unique Reg. Code") }}: {{ company.registration_number }}
              </div>
              <div>
                {{ $t("License to organize betting activity") }}:
                {{ company.license_number }}
              </div>
            </div>
            <div>
              <div class="text-right">{{ $t("Date") }}</div>
              <h3 class="text-right">
                <span v-if="type === 'day'">{{
                  mom(this.dateStart).format("D")
                }}</span>
                {{ $t(mom(this.dateStart).format("MMMM")) }}
                {{ mom(this.dateStart).format("YYYY") }}
              </h3>
            </div>
          </div>
          <div
            class="
              mb-4
              d-flex
              flex-row
              justify-content-between
              align-items-center
            "
          >
            <div style="width: 20%"></div>
            <div style="width: 60%">
              <h2 class="text-center">
                {{ $t("Operators Report") }}
              </h2>
            </div>
            <div class="text-right print-display" style="width: 20%">
              {{ $t("Printed") }}: {{ datePrint.format("HH:mm, DD/MM/YYYY") }}
            </div>
          </div>
          <div class="mt-2">
            <b-table
              id="operators-report-table-printing"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              bordered
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template v-slot:head(shop_code)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(shop_name)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(username)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(surname)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(income_bets)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(income_slots)="data">{{
                $t(data.label)
              }}</template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value">{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(income_bets)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(income_slots)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

function unescape(str) {
  return (str + "===".slice((str.length + 3) % 4))
    .replace(/-/g, "+")
    .replace(/_/g, "/");
}

function decode(str, encoding) {
  return Buffer.from(unescape(str), "base64").toString(encoding || "utf8");
}

export default {
  name: "operatorsReportPrinting",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
  },
  data: function () {
    return {
      tableName: "operatorsReportPrinting",

      isBusy: false,
      fields: [
        {
          key: "shop_code",
          label: "Shop Code",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "username",
          label: "Username",
          sortable: false,
          ignore: false,
          class: "",
        },
        {
          key: "surname",
          label: "Surname",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "name",
          label: "Name",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "income_bets",
          label: "Betting Income",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "income_slots",
          label: "Slot Income",
          sortable: false,
          ignore: true,
          class: "",
        },
      ],
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",

      shopName: "",
      company: {
        name: "",
        address: "",
        cui: "",
        registration_number: "",
        license_number: "",
      },

      dateEnd: null,
      dateField: null,
      dateStart: null,
      exactFields: [],
      exactValues: [],
      fieldsExp: [],
      likeFields: [],
      likeValues: [],

      scrollHeight: 0,
      datePrint: moment(),
      type: "",
    };
  },
  mounted() {
    let data = this.$router.history.current.query.data;
    data = decode(data);
    console.log("data:", data);
    const queryParms = JSON.parse(data);

    this.dateField = queryParms.dateField;
    this.dateStart = queryParms.dateStart;
    this.dateEnd = queryParms.dateEnd;
    this.exactFields = queryParms.exactFields ? queryParms.exactFields : [];
    this.exactValues = queryParms.exactValues ? queryParms.exactValues : [];

    this.exactFields.forEach((v, i) => {
      if (v === "period") {
        this.type = this.exactValues[i][0];
      }
    });

    this.fieldsExp = queryParms.fields ? queryParms.fields : [];
    this.likeFields = queryParms.likeFields ? queryParms.likeFields : [];
    this.likeValues = queryParms.likeValues ? queryParms.likeValues : [];
    this.page = parseInt(queryParms.page);
    this.rowsPerPage = parseInt(queryParms.rowsPerPage);

    this.$store.dispatch("global/setLanguage", queryParms.lang);

    const self = this;
    this.intervalID = window.setInterval(() => {
      if (self.$refs.wrapper) {
        const newHeight = self.$refs.wrapper.scrollHeight;
        if (newHeight != self.scrollHeight) {
          self.scrollHeight = newHeight;
          self.sendMessage(
            JSON.stringify({ type: "resize", height: newHeight })
          );
        }
      }
    }, 100);

    this.onMessageCB = this.onMessage.bind(this);
    this.bindEvent(window, "message", this.onMessageCB);
  },
  destroyed() {
    window.clearInterval(this.intervalID);
    this.unbindEvent(window, "message", this.onMessageCB);
  },
  methods: {
    mom(val) {
      return moment(val);
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "operators-report-table-printing");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      this.$store
        .dispatch("operatorsReport/fetch", paginationData)
        .then((resp) => {
          this.totalRows = resp.data.total;
          if (resp.data.company) {
            this.company = { ...this.company, ...resp.data.company };
          }
          resp.data.rows.forEach((item, index) => {
            if (item.eshop_id) {
              item.shop_name = {
                to: item.eshop_id,
                name: item.shop_name,
              };
              item.shop_code = {
                to: item.eshop_id,
                name: item.shop_code,
              };
            }
          });
          callback(resp.data.rows);
        })
        .catch((err) => {
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      paginationData.likeValues = [];
      paginationData.likeFields = [];

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      if (this.exactFields.length && this.exactValues.length) {
        paginationData.exactFields = this.exactFields;
        paginationData.exactValues = this.exactValues;
      } else {
        paginationData.exactFields = [];
        paginationData.exactValues = [];
      }

      console.log(this.dateStart, this.dateField);
      if (this.dateStart && this.dateField) {
        paginationData.dateField = this.dateField;
        paginationData.dateStart = this.dateStart;
        paginationData.dateEnd = this.dateEnd;
      } else {
        paginationData.dateField = "save_time";
        // this.dateField;
        // item.field;
        // paginationData.dateField = this.dateField;
        paginationData.dateStart = moment().startOf("month");
        paginationData.dateEnd = moment().endOf("month");
      }

      return { body: paginationData, print: true };
    },
    rowClicked(item, index, event) {},
    redirect() {},
    onMessage(e) {
      let data = {};
      try {
        data = JSON.parse(e.data);
      } catch (err) {
        // noop
      }
      if (data) {
        if (data.type && data.type == "print") {
          this.datePrint = moment();
          this.$nextTick(() => {
            window.print();
          });
        }
      }
    },
    bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent("on" + eventName, eventHandler);
      }
    },
    unbindEvent(element, eventName, eventHandler) {
      if (element.removeEventListener) {
        element.removeEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eventName, eventHandler);
      }
    },
    sendMessage(msg) {
      // Make sure you are sending a string, and to stringify JSON
      window.parent.postMessage(msg, "*");
    },
  },
};
</script>
<style lang="css">
body {
  background-color: #fff !important;
}
@page {
  size: A4;
  margin: 0;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
  #operators-report-table-printing {
    border-color: #000 !important;
    border-width: 1px 0 0 1px !important;
  }
  #operators-report-table-printing > thead > tr > th {
    border-color: #000 !important;
    border-width: 0 1px 1px 0 !important;
  }
  #operators-report-table-printing > tbody > tr > td {
    border-color: #000 !important;
    border-width: 0 1px 1px 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.kt-portlet {
  margin-bottom: 0;
  border-radius: 0;
  color: #000;
}
h2,
h3 {
  color: #000;
}
.print-display {
  opacity: 0;
}
@media print {
  .kt-portlet {
    font-size: 20px;
  }
  .print-display {
    opacity: 1;
  }
}

::v-deep #operators-report-table-printing th:nth-child(n + 3) {
  text-align: right;
}
::v-deep #operators-report-table-printing td:nth-child(n + 3) {
  text-align: right;
}
</style>
